import React from 'react';
import {ServicesBlockElement} from '../elements/index';

export const ServicesBlockComponent = (props) => {

	return(
        <section className="col-12 kiwi-services-block">
			{props.content.services && props.content.services.map((service, i) => {
				return <ServicesBlockElement key={i}
											 heading={service.heading}
											 image={service.image}
											 text={service.text}
											 button={service.button}
											 blockBackgroundColor={service.blockBackgroundColor}
											 blockTextColor={service.blockTextColor} />
				})
			}
		</section>
	);
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/components/ServicesBlockComponent.js